import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { Button } from '@/components/ui/button/button.component';
import { Card } from '@/components/ui/card.component';
import { Link } from '@/components/ui/link/link.component';
import { Typography } from '@/components/ui/typography/typography.component';
import { TypographyVariant } from '@/components/ui/typography/typography.type';
import { useWhatsappLinkWithAnalytics } from '@/hooks/use-whatsapp/use-whatsapp-link-with-analytics.hook';
import { phonePatientSac } from '@/utils/consts/sac.consts';
import { patientSacWhatsappMessage } from '@/utils/consts/cta-whatsapp-messages.consts';
import { AnalyticsEnum } from '@/types/enums/analytics/analytics.enum';

export const PatientContactSection = () => {
  const { url: whatsappUrl } = useWhatsappLinkWithAnalytics(phonePatientSac, patientSacWhatsappMessage);

  return (
    <section className="w-full pt-6">
      <Card
        className="flex flex-col gap-2.5 p-5 lg:flex-row lg:items-center lg:justify-between lg:gap-6"
        data-testid={DataTestIdEnum.FAQ_PATIENT_CONTACT_CARD}
      >
        <div className="flex flex-col gap-2">
          <Typography
            variant={TypographyVariant.MEDIUM_SUBTITLE}
            as="h2"
            className="text-xl font-bold text-gray-900"
          >
            Está com problemas?
          </Typography>
          <Typography variant={TypographyVariant.BODY_TEXT} as="p">
            Fale com a gente que vamos te ajudar.
          </Typography>
        </div>
        <Button
          asChild
          color="primary"
          startIcon={faWhatsapp}
          startIconClassName="w-5 h-5"
          className="w-full lg:w-auto lg:shrink-0"
          data-testid={DataTestIdEnum.FAQ_PATIENT_WHATSAPP_SAC_BUTTON}
        >
          <Link
            prefetch={false}
            href={whatsappUrl}
            target="_blank"
            data-analytics-event={AnalyticsEnum.CLICK_FAQ_TALK_TO_SAC_BUTTON}
          >
            Falar com SAC
          </Link>
        </Button>
      </Card>
    </section>
  );
};
